<template>
	<v-container fluid >
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{$t('buttons.back')}}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 md12 pa-1 sm12 xl6 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row wrap>
									<v-flex xs12>
										<InputField :error="serviceTypeValidation.name"
													:label="'* '+$t('fields.name')"
													v-model="serviceType.name"></InputField>
									</v-flex>
									<v-flex xs12>
										<CheckBox
											:label="$t('fields.active')"
											v-model="serviceType.active"></CheckBox>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField";
	import CheckBox from "./trinkets/CheckBox";

	export default {
		name: "ServiceType",
		components: {CheckBox, InputField},
		props: {
			id: Number,
			action: String
		},
		data: function () {
			return {
				initialLoad: false,
				serviceType: {
					id: this.$route.params.id,
					name: '',
					active: true
				},
				serviceTypeValidation: {
					id: '',
					name: '',
					active: ''
				},

			}
		},
		watch: {
			serviceType: {
				handler: function () {
					if (this.initialLoad) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		methods: {
			backClick() {
				this.$router.go(-1);
			},
			saveClick() {
				let success = true;

				if (this.serviceType.name.trim() == '') {
					success = false;
					this.serviceTypeValidation.name = this.$t('alerts.fieldError');
				} else {
					this.serviceTypeValidation.name = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.serviceType.id != 0) {
						action = 'put';
						addition = '/' + vm.serviceType.id;
					}
					vm.$APICall(action, 'service-types' + addition, vm.serviceType, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.serviceType.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			if (this.serviceType.id != 0) {
				let vm = this;
				this.$APICall('get', 'service-types/' + this.serviceType.id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.serviceType = usableData;
						vm.$myStore.commit('setBreadcrumbs', [
							{text: vm.$t('modules.supplierServiceTypes'), href: '/#/service-types', disabled: false},
							{text: vm.serviceType.name, href: '/#/service-types/' + vm.serviceType.id, disabled: true}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{text: this.$t('modules.supplierServiceTypes'), href: '/#/service-types', disabled: false},
					{text: this.$t('modules.newServiceType'), href: '/#/service-types/0', disabled: true}
				]);
				this.initialLoad = true;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.changesHappened) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					next(result);
				});
			} else {
				next(true);
			}
		}
	}
</script>

<style scoped>
</style>
